<template>
    <div :class="['d-flex w-100 align-center justify-space-between font-weight-light', className]">
        <slot />
        <card-button :link="link" :target="TARGET_TYPES.SELF" height="46" min-width="138" class="mr-0 ml-auto px-1" @click="handleClick">
            {{ text }}
        </card-button>
    </div>
</template>

<script setup lang="ts">
import CardButton from '@/features/common/components/CardButton.vue';
import { TARGET_TYPES } from '@/constants';

interface ButtonWithDescription {
    disabled?: boolean;
    link?: string;
    text: string;
    className?: string;
}

const emit = defineEmits<{
    click: [];
}>();

withDefaults(defineProps<ButtonWithDescription>(), {
    link: '',
    disabled: false,
    className: 'mt-3'
});

const handleClick = () => {
    emit('click');
};
</script>
